import SupplierAssessmentContainer from "./containers/SupplierAssessmentContainer";
import "./styles.scss";
export default SupplierAssessmentContainer;
